import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import DatePicker , { registerLocale } from "react-datepicker";
import pt_br from "date-fns/locale/pt-BR";
import { getMessagemErro } from "../../utils/erro";
import api from "../../services/api";

import './SolicitacaoComunicacao.css';
import { FEDERAL, ESTADUAL, MUNICIPAL } from "../../providers/constEsferasAdministrativas";
import { EMAIL, PLATAFORMA } from "../../providers/constCanaisComunicacao";
import { RESPONSAVEL_TECNICO, DIRIGENTE_TI } from "../../providers/constAtribuicoesGestor";
import { GESTOR_API, GESTOR_ARQUIVO_GV } from "../../providers/constGestorFornecedor";
import { ID_AUDIENCIA_SOL_COM_CONSUMIDOR_API, ID_AUDIENCIA_SOL_COM_FORNECEDOR_API, ID_AUDIENCIA_SOL_COM_OPERADOR_API, ID_AUDIENCIA_SOL_COM_CONSUMIDOR_ARQUIVO_GV, ID_AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV, ID_AUDIENCIA_SOL_COM_PONTOS_FOCAIS } from "../../providers/constAudienciaSolicitacaoComunicacao";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

registerLocale("pt_br", pt_br);
export const SolicitacaoComunicacaoEdit =

withRouter(

// redux
connect(
	(null), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				solicitacao: {
					id: '',
					numero: '',
					situacao: '',
					nomeSituacao: '',
					audiencia: '',
					nenhumPerfilPesquisaSelecionado: true,
					aplicacacoesFornecedoras: [],
					arquivosGV: [],
					ufs: [],
					orgaos: [],
					esferasAdministrativas: [],
					naturezasJuridicas: [],
					canaisComunicacao: [],
					tiposGestores: [],
					assunto: '',
					mensagem: '',
					dataEnvioComunicacao: new Date(),
					liberarParaProcessamento: false,
					alteracaoPermitida: true,
					liberacaoProcessamentoPermitida: false,
				},
				aplicacacoesFornecedorasDisponiveis: [],
				arquivosGVDisponiveis: [],
				orgaosDisponiveis: [],
				orgaosOperadoresDisponiveis: [],
				ufsDisponiveis: [],
				esferasAdministrativasDisponiveis: [ESTADUAL, FEDERAL, MUNICIPAL],
				naturezasJuridicasDisponiveis: [],
				canaisComunicacaoDisponiveis: [EMAIL, PLATAFORMA],
				tiposGestoresDisponiveis: [GESTOR_API, GESTOR_ARQUIVO_GV, DIRIGENTE_TI, RESPONSAVEL_TECNICO],
				carregandoFornecedoras: false,
				carregandoArquivosGV: false,
				carregandoOrgaos: false,
				carregandoOrgaosOperadores: false,
				carregandoNaturezas: false,
				carregandoUfs: false,
				exibeModalConfirmacao : false,
				msgModal: '',
				botoesHabilitados : true,
			};
			
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleAudienciaChange = this.handleAudienciaChange.bind(this);
			this.handleEsferasAdministrativasChange = this.handleEsferasAdministrativasChange.bind(this);
			this.handleUfsChange = this.handleUfsChange.bind(this);
			this.carregarOrgaos = this.carregarOrgaos.bind(this);
			this.carregarOrgaosOperadores = this.carregarOrgaosOperadores.bind(this);
			this.carregarFornecedoras = this.carregarFornecedoras.bind(this);
			this.carregarArquivos = this.carregarArquivos.bind(this);
			this.carregarNaturezasJuridicas = this.carregarNaturezasJuridicas.bind(this);
			this.carregarUfs = this.carregarUfs.bind(this);
			this.salvar = this.salvar.bind(this);
			this.novo = this.novo.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Solicitação de Comunicação</h1>
					</div>
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;

			if(id){
				api.get(`/api/solicitacao-comunicacao/${id}`)
					.then(response => { 
						const solicitacao = response.data;

						this.setState((prevState) => ({ ...prevState, solicitacao }));
						this.carregarFornecedoras(solicitacao);
						this.carregarArquivos(solicitacao);
					})
					.catch(erro => {
						const msg = getMessagemErro("Não foi possível recuperar a solicitação de comunicação.", erro);
						console.log(JSON.stringify(msg));
						this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					});
				}
				
				this.carregarOrgaos();
				this.carregarOrgaosOperadores();
				this.carregarNaturezasJuridicas();
				this.carregarUfs();
			}

		renderForm() {
			const { solicitacao, aplicacacoesFornecedorasDisponiveis, orgaosDisponiveis, orgaosOperadoresDisponiveis,
					ufsDisponiveis, esferasAdministrativasDisponiveis, naturezasJuridicasDisponiveis, arquivosGVDisponiveis,
					canaisComunicacaoDisponiveis, tiposGestoresDisponiveis, carregandoOrgaos } = this.state;

			const desabilitaEsferaUfOrgao = solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_FORNECEDOR_API 
											|| solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV 
											|| solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_OPERADOR_API;

			return(
				<div className="container-fluid">

					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalConfirmacao}
						handleOk={() => this.executaOperacao()}
						handleCancel={() => this.setState((prevState) => ({...prevState, exibeModalConfirmacao: false}))}
						message={this.state.msgModal}/>

					<div className="br-form">
						{ solicitacao.id &&
							<div className="row">
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Número:</label>
											<input value={solicitacao.numero} readOnly/>
										</div>
									</div>
								</div>
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Situação:</label>
											<input value={solicitacao.nomeSituacao} readOnly/>
										</div>
									</div>
								</div>
							</div>
						}
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Audiência:</label>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<div class="check input br-radio recuo_esquerda">
									<input type="radio" name="audiencia" value="" 
										checked={!solicitacao.audiencia} 
										onChange={this.handleAudienciaChange} />
									<label>Todos os Gestores</label>
								</div>	
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<div class="check input br-radio recuo_esquerda">
									<input type="radio" name="audiencia" id="audiencia"
										value={ID_AUDIENCIA_SOL_COM_CONSUMIDOR_API} 
										checked={solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_CONSUMIDOR_API} 
										onChange={this.handleAudienciaChange} />
									<label>Somente para Consumidores de APIs</label>
								</div>	
							</div>	
							{solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_CONSUMIDOR_API &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>APIs:</label>
										</div>
										<SelectSearch
											id="aplicacacoesFornecedoras"
											isMulti={true}
											maxMultiSelectValues={3}
											name="aplicacacoesFornecedoras"
											options={aplicacacoesFornecedorasDisponiveis.map(fornecedora => ({ id: fornecedora.id, nome: fornecedora.nome }))}
											onChange={values => this.handleMultiSelectChange('aplicacacoesFornecedoras', values)}
											value={solicitacao.aplicacacoesFornecedoras}
											placeholder="Consumidores de todas as APIs, sem distinção"
											noOptionsMessage="Nenhuma API encontrada"
											optionName="nome"
											optionValue="id"
											isLoading={this.state.carregandoFornecedoras}
											includeAllOption={false}
										/>
									</div>
								</div>	
							}
						</div>
						<div className="row">
							<div className="col-sm-4">									
								<div class="check input br-radio recuo_esquerda">
									<input type="radio" name="audiencia" id="audiencia"
										value={ID_AUDIENCIA_SOL_COM_FORNECEDOR_API} 
										checked={solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_FORNECEDOR_API} 
										onChange={this.handleAudienciaChange} />
									<label>Somente para Fornecedores de APIs</label>
								</div>
							</div>	
							{solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_FORNECEDOR_API &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>APIs:</label>
										</div>
										<SelectSearch
											id="aplicacacoesFornecedoras"
											isMulti={true}
											maxMultiSelectValues={3}
											name="aplicacacoesFornecedoras"
											options={aplicacacoesFornecedorasDisponiveis.map(fornecedora => ({ id: fornecedora.id, nome: fornecedora.nome }))}
											onChange={values => this.handleMultiSelectChange('aplicacacoesFornecedoras', values)}
											value={solicitacao.aplicacacoesFornecedoras}
											placeholder="Fornecedores de todas as APIs, sem distinção"
											noOptionsMessage="Nenhuma API encontrada"
											optionName="nome"
											optionValue="id"
											isLoading={this.state.carregandoFornecedoras}
											includeAllOption={false}
										/>
									</div>
								</div>	
							}
						</div>

						<div className="row">
							<div className="col-sm-4">
								<div class="check input br-radio recuo_esquerda">
									<input type="radio" name="audiencia" id="audiencia"
										value={ID_AUDIENCIA_SOL_COM_OPERADOR_API} 
										checked={solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_OPERADOR_API} 
										onChange={this.handleAudienciaChange} />
									<label>Somente para Operadores de APIs</label>
								</div>
							</div>	
							{solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_OPERADOR_API &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Órgãos:</label>
										</div>
										<SelectSearch
											id="orgaos"
											isMulti={true}
											maxMultiSelectValues={3}
											name="orgaos"
											options={orgaosOperadoresDisponiveis.map(orgao => ({ id: orgao.id, nome: orgao.nome }))}
											onChange={values => this.handleMultiSelectChange('orgaos', values)}
											value={solicitacao.orgaos}
											placeholder="Operadores de todos os órgãos, sem distinção"
											noOptionsMessage="Nenhum órgão operador encontrado"
											optionName="nome"
											optionValue="id"
											isLoading={this.state.carregandoOrgaosOperadores}
											includeAllOption={false}
										/>
									</div>
								</div>	
							}
						</div>

						<div className="row">
							<div className="col-sm-4">
								<div class="check input br-radio recuo_esquerda">
									<input type="radio" name="audiencia" id="audiencia"
										value={ID_AUDIENCIA_SOL_COM_CONSUMIDOR_ARQUIVO_GV} 
										checked={solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_CONSUMIDOR_ARQUIVO_GV}
										onChange={this.handleAudienciaChange} />
									<label>Somente para Consumidores de Arquivos</label>
								</div>
							</div>	
							{solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_CONSUMIDOR_ARQUIVO_GV &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Arquivos:</label>
										</div>
										<SelectSearch
											id="arquivosGV"
											isMulti={true}
											maxMultiSelectValues={3}
											name="arquivosGV"
											options={arquivosGVDisponiveis.map(arquivoGV => ({ id: arquivoGV.id, nome: arquivoGV.nome }))}
											onChange={values => this.handleMultiSelectChange('arquivosGV', values)}
											value={solicitacao.arquivosGV}
											placeholder="Consumidores de todos os arquivos, sem distinção"
											noOptionsMessage="Nenhum arquivo encontrado"
											optionName="nome"
											optionValue="id"
											isLoading={this.state.carregandoArquivosGV}
											includeAllOption={false}
										/>
									</div>
								</div>	
							}
						</div>

						<div className="row">
							<div className="col-sm-4">
								<div class="check input br-radio recuo_esquerda">
									<input type="radio" name="audiencia" id="audiencia"
										value={ID_AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV} 
										checked={solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV}
										onChange={this.handleAudienciaChange} />
									<label>Somente para Fornecedores de Arquivos</label>
								</div>
							</div>	
							{solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Arquivos:</label>
										</div>
										<SelectSearch
											id="arquivosGV"
											isMulti={true}
											maxMultiSelectValues={3}
											name="arquivosGV"
											options={arquivosGVDisponiveis.map(arquivoGV => ({ id: arquivoGV.id, nome: arquivoGV.nome }))}
											onChange={values => this.handleMultiSelectChange('arquivosGV', values)}
											value={solicitacao.arquivosGV}
											placeholder="Fornecedores de todos os arquivos, sem distinção"
											noOptionsMessage="Nenhum arquivo encontrado"
											optionName="nome"
											optionValue="id"
											isLoading={this.state.carregandoArquivosGV}
											includeAllOption={false}
										/>
									</div>
								</div>	
							}
						</div>

						<div className="row">
							<div className="col-sm-4">
								<div class="check input br-radio recuo_esquerda">
									<input type="radio" name="audiencia" id="audiencia"
										value={ID_AUDIENCIA_SOL_COM_PONTOS_FOCAIS} 
										checked={solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_PONTOS_FOCAIS}
										onChange={this.handleAudienciaChange} />
									<label>Somente para Pontos Focais</label>
								</div>
							</div>
							{solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_PONTOS_FOCAIS &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Naturezas Jurídicas:</label>
										</div>
										<SelectSearch
											id="naturezasJuridicas"
											isMulti={true}
											maxMultiSelectValues={3}
											name="naturezasJuridicas"
											options={naturezasJuridicasDisponiveis.map(natureza => ({ id: natureza.id, nome: natureza.id + " - " + natureza.nome }))}
											onChange={values => this.handleMultiSelectChange('naturezasJuridicas', values)}
											value={solicitacao.naturezasJuridicas}
											placeholder="Pontos focais de todas as naturezas jurídicas, sem distinção"
											noOptionsMessage="Nenhuma natureza jurídca encontrada"
											optionName="nome"
											optionValue="id"
											isLoading={this.state.carregandoNaturezas}
											includeAllOption={false}
										/>
									</div>
								</div>	
							}
						</div>
						
						<br/>

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label for="esferasAdministrativas">Esferas Administrativas de destino:</label>
									</div>	
									<SelectSearch
										id="esferasAdministrativasDisponiveis	"
										name="esferasAdministrativasDisponiveis"
										isMulti={true}
										maxMultiSelectValues={3}
										options={esferasAdministrativasDisponiveis.map(esfera => ({ codigo: esfera.codigo, nome: esfera.nome }))}
										onChange={values => this.handleEsferasAdministrativasChange(values)}
										value={solicitacao.esferasAdministrativas}
										placeholder="Todas as esferas administrativas, sem distinção"
										noOptionsMessage="Nenhuma esfera administrativa encontrada"
										optionName="nome"
										optionValue="codigo"
										disabled={desabilitaEsferaUfOrgao}
										includeAllOption={false}
									/>
								</div>
							</div>

							<div className="col-md">
								<div className="field">
									<div className="input">
										<label for="ufs">Unidades da Federação de destino:</label>
									</div>	
									<SelectSearch
										id="ufs"
										isMulti={true}
										maxMultiSelectValues={3}
										name="ufs"
										options={ufsDisponiveis.map(uf => ({ id: uf.id, nome: uf.nome }))}
										onChange={values => this.handleUfsChange(values)}
										value={solicitacao.ufs}
										placeholder="Todas as unidades da federação, sem distinção"
										noOptionsMessage="Nenhuma UF encontrada"
										optionName="nome"
										optionValue="id"
										isLoading={this.state.carregandoUfs}
										disabled={desabilitaEsferaUfOrgao}
										includeAllOption={false}
									/>
								</div>
							</div>

							{ solicitacao.audiencia !== ID_AUDIENCIA_SOL_COM_OPERADOR_API &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label for="orgaos">Órgãos de destino:</label>
										</div>	
										{ carregandoOrgaos === false && orgaosDisponiveis.length > 0 &&
											<SelectSearch
												id="orgaos"
												isMulti={true}
												maxMultiSelectValues={3}
												name="orgaos"
												options={orgaosDisponiveis.map(orgao => ({ id: orgao.id, nome: orgao.nome }))}
												onChange={values => this.handleMultiSelectChange('orgaos', values)}
												value={solicitacao.orgaos}
												placeholder="Todos os órgãos, sem distinção"
												noOptionsMessage="Nenhum órgão encontrado"
												optionName="nome"
												optionValue="id"
												isLoading={carregandoOrgaos}
												disabled={desabilitaEsferaUfOrgao}
												includeAllOption={false}
											/>
										}
										{ carregandoOrgaos === false && orgaosDisponiveis.length === 0 &&
											<p>Nenhum órgão encontrado.</p>
										}
										{ carregandoOrgaos === true  && 
											<button className="br-button is-secondary is-circle is-loading" type="button"/>
										}
									</div>
								</div>
							}
						</div>

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label for="tiposGestores">Destinatários:</label>
									</div>	
									<SelectSearch
										id="tiposGestores"
										isMulti={true}
										maxMultiSelectValues={4}
										name="tiposGestores"
										options={tiposGestoresDisponiveis.map(tipoGestor => ({ codigo: tipoGestor.codigo, nome: tipoGestor.nome }))}
										onChange={values => this.handleMultiSelectChange('tiposGestores', values)}
										value={solicitacao.tiposGestores}
										placeholder="Todos os gestores, sem distinção"
										noOptionsMessage="Nenhum perfil encontrado"
										optionName="nome"
										optionValue="codigo"
										includeAllOption={false}
									/>
								</div>
							</div>

							<div className="col-md">
								<div className="field">
									<div className="input">
										<label for="canaisComunicacao">Canais de Comunicação:</label>
									</div>	
									<SelectSearch
										id="canaisComunicacao"
										isMulti={true}
										maxMultiSelectValues={3}
										name="canaisComunicacao"
										options={canaisComunicacaoDisponiveis.map(canal => ({ codigo: canal.codigo, nome: canal.nome }))}
										onChange={values => this.handleMultiSelectChange('canaisComunicacao', values)}
										value={solicitacao.canaisComunicacao}
										placeholder="Selecione os canais de comunicação"
										noOptionsMessage="Nenhum canal de comunicação encontrado"
										optionName="nome"
										optionValue="codigo"
									/>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md">  
								<div className="field">
									<div className="input"> 
										<label htmlFor="assunto">Assunto:</label>
										<input type="text" name="assunto" value={solicitacao.assunto} onChange={this.handleInputChange} maxLength={200}/>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md">  
								<div className="field">
									<div className="input"> 
										<label htmlFor="mensagem">Mensagem:</label>
										<textarea name="mensagem" value={solicitacao.mensagem} onChange={this.handleInputChange} maxLength={5000} style={{height:"90px"}}/>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-sm-3">
                                <div className="field">
                                    <div className="input">
                                        <label htmlFor="dataEnvioComunicacao">Data de envio da comunicação:</label>
										<DatePicker 
											locale="pt_br" 
											dateFormat="dd/MM/yyyy" 
											
											selected={solicitacao.dataEnvioComunicacao} 
												disableClock={true}
												onChange={data => {
													const solicitacao = this.state.solicitacao;
													solicitacao['dataEnvioComunicacao'] = data;
													this.setState((prevState) => ({...prevState, solicitacao}))}}
											/>
                                    </div>
                                </div>
                            </div>
                        </div>

						{/* button actions */}
						<div className="actions-button">
							<div className="actions justify-content-start">
								{this.state.solicitacao.alteracaoPermitida && 
									<button type="button" className="button is-primary" onClick={(e) => this.salvar(e, false)} disabled={!this.state.botoesHabilitados}>{solicitacao.id ? 'Alterar' : 'Incluir'}</button>
								}

								{solicitacao.liberacaoProcessamentoPermitida &&
									<button type="button" className="button is-secondary" 
										onClick={(e) => this.confirmaOperacao(this.salvar, [e, true], "Deseja realmente liberar a solicitação para processamento?")} 
										disabled={!this.state.botoesHabilitados}>Liberar para Processamento</button>
								}	

								{this.state.solicitacao.id && 
									<button type="button" className="button is-secondary botaoNovo" onClick={this.novo} disabled={!this.state.botoesHabilitados}>Nova Solicitação</button>
								}

								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
					</div>
				</div>
				
			);
		}

		validaFormulario(){
			let mensagens = [];
			const { solicitacao } = this.state;
			const { canaisComunicacao, assunto, mensagem, dataEnvioComunicacao } = solicitacao;

			if(!canaisComunicacao || canaisComunicacao.length === 0){
				mensagens.push({mensagem: "Selecione pelo menos um canal de comunicação."})
			}

			if(!assunto || assunto.trim().length === 0){
				mensagens.push({mensagem: "Assunto obrigatório."})
			}

			if(!mensagem || mensagem.trim().length === 0){
				mensagens.push({mensagem: "Mensagem obrigatória."})
			}

			if(dataEnvioComunicacao == null){
				mensagens.push({mensagem: "Data de envio da comunicação obrigatória."})
			} else {
				const dataAtual = new Date();
				dataAtual.setHours(0, 0, 0, 0);

				if(dataEnvioComunicacao < dataAtual){
					mensagens.push({mensagem: "Data de envio da comunicação não pode ser uma data passada."})
				}

			}

		
			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const solicitacao = this.state.solicitacao;
			solicitacao[nome] = valor;
			this.setState((prevState) => ({...prevState, solicitacao }));
		}

		handleAudienciaChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const solicitacao = this.state.solicitacao;
			solicitacao[nome] = Number(valor);

			if(solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_FORNECEDOR_API 
				|| solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV 
				|| solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_OPERADOR_API ) {

				solicitacao.ufs = [];
				solicitacao.orgaos = [];
				solicitacao.esferasAdministrativas = [];
			}

			this.setState((prevState) => ({ ...prevState, solicitacao, aplicacacoesFornecedorasDisponiveis: [], arquivosGVDisponiveis: [] }));
			this.carregarFornecedoras(solicitacao);
			this.carregarArquivos(solicitacao);
		}

		handleMultiSelectChange(propriedade, values){
			const valoresSelecionados = values.target.value;
			const solicitacao = this.state.solicitacao;
			solicitacao[propriedade] = valoresSelecionados;
			this.setState((prevState) => ({ ...prevState, solicitacao }));
		}

		handleEsferasAdministrativasChange(values){
			const esferasAdministrativasSelecionadas = values.target.value;
			const solicitacao = this.state.solicitacao;
			solicitacao['esferasAdministrativas'] = esferasAdministrativasSelecionadas;
			this.setState((prevState) => ({ ...prevState, solicitacao }));
			this.carregarOrgaos(esferasAdministrativasSelecionadas.map(esfera => esfera.codigo), solicitacao['ufs'].map(uf => uf.id));
		}

		handleUfsChange(values){
			const ufsSelecionadas = values.target.value;
			const solicitacao = this.state.solicitacao;
			solicitacao['ufs'] = ufsSelecionadas;
			this.setState((prevState) => ({ ...prevState, solicitacao,}));
			this.carregarOrgaos(solicitacao['esferasAdministrativas'].map(esfera => esfera.codigo), ufsSelecionadas.map(uf => uf.id));
		}

		carregarOrgaos(esferasAdministrativas, unidadesFederacao) {
			this.setState((prevState) => ({ ...prevState, carregandoOrgaos : true}));

			let url = '/api/orgao/clientes?ativos=true';
			
			if (esferasAdministrativas) {
				url += `&esferasAdministrativas=${esferasAdministrativas}`;
			}

			if (unidadesFederacao) {
				url += `&unidadesFederacao=${unidadesFederacao}`;
			}

			api.get(url)
				.then(response => { 
					this.setState((prevState) => ({ ...prevState, orgaosDisponiveis: response.data })) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os órgãos.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.finally(() => {
					this.setState((prevState) => ({ ...prevState, carregandoOrgaos : false}));
				});
		}

		carregarOrgaosOperadores() {
			this.setState((prevState) => ({ ...prevState, carregandoOrgaosOperadores : true}));
			api.get('/api/orgao/operadores')
				.then(response => { 
					this.setState((prevState) => ({ ...prevState, orgaosOperadoresDisponiveis: response.data }) )
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os órgãos operadores.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.finally(() => {
					this.setState((prevState) => ({ ...prevState, carregandoOrgaosOperadores : false}));
				});
		}

		carregarFornecedoras(solicitacao) {
			if(!solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_CONSUMIDOR_API && !solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_FORNECEDOR_API) {
				return;
			}

			this.setState((prevState) => ({ ...prevState, carregandoFornecedoras : true}));
			let url = '/api/aplicacao-fornecedora';

			if(solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_CONSUMIDOR_API){
				url += '/adesoes-ativas';
			}

			api.get(url)
				.then(response => { 
					this.setState((prevState) => ({ ...prevState, aplicacacoesFornecedorasDisponiveis: response.data })) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar as APIs.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.finally(() => {
					this.setState((prevState) => ({ ...prevState, carregandoFornecedoras : false}));
				});
		}

		carregarArquivos(solicitacao) {
			if(!solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_CONSUMIDOR_ARQUIVO_GV && !solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV) {
				return;
			}
			this.setState((prevState) => ({ ...prevState, carregandoArquivosGV: true}));
			let url = '/api/arquivo-gv';

			if(solicitacao.consumidoresArquivosGV){
				url += '/adesoes-ativas';
			}

			api.get(url)
				.then(response => { 
					this.setState((prevState) => ({ ...prevState, arquivosGVDisponiveis: response.data })) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os Arquivos.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.finally(() => {
					this.setState((prevState) => ({ ...prevState, carregandoArquivosGV : false}));
				});
		}

		carregarNaturezasJuridicas() {
			this.setState((prevState) => ({ ...prevState, carregandoNaturezas : true}));

			api.get('/api/natureza-juridica')
				.then(response => { 
					this.setState((prevState) => ({ ...prevState, naturezasJuridicasDisponiveis: response.data })) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar as Naturezas Jurídicas.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.finally(() => {
					this.setState((prevState) => ({ ...prevState, carregandoNaturezas : false}));
				});
		}

		carregarUfs() {
			this.setState((prevState) => ({ ...prevState, carregandoUfs : true}));

			api.get('/api/unidade-federacao')
				.then(response => { 
					this.setState((prevState) => ({ ...prevState, ufsDisponiveis: response.data })) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar as Unidades da Federação.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.finally(() => {
					this.setState((prevState) => ({ ...prevState, carregandoUfs : false}));
				});
		}
		
		novo(e){
			const rotaParaNovo = "/solicitacao-comunicacao/new";
			if (rotaParaNovo === this.props.location.pathname) {
				this.props.history.push("/");
				this.props.history.goBack();
			} else {
				this.props.history.push(rotaParaNovo);
			}
		}

		confirmaOperacao(funcao, parametros, msgModal) {
			this.setState((prevState) => ({ ...prevState, 
					exibeModalConfirmacao: true,
					parametros,
					funcao,
					msgModal,
				}
			));
		}

		executaOperacao () {
			this.state.funcao.apply(this, this.state.parametros);
			this.setState((prevState) => ({ ...prevState, exibeModalConfirmacao : false}));
		}

		salvar (e, liberarParaProcessamento){
			this.props.limpaMensagem();
			this.setState((prevState) => ({ ...prevState, exibeModalConfirmacao : false}));

			const { solicitacao } = this.state;

			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			const method = solicitacao.id ? 'put' : 'post';
			let url = '/api/solicitacao-comunicacao';
			if(solicitacao.id){
				url = url + '/' + solicitacao.id;
			}

			solicitacao.liberarParaProcessamento = liberarParaProcessamento;

			const options = {
				method,
				url,
				data: solicitacao
			}

			this.props.mostraAguardando();
			this.setState((prevState) => ({ ...prevState, botoesHabilitados : false}));
			api(options)
				.then(response => { 
					let operacao = 'incluída';
					if(this.state.solicitacao.id) {
						if(liberarParaProcessamento) {
							operacao = 'liberada para processamento';
						} else {
							operacao = 'alterada';
						}
					}
					const mensagem = `Solicitação de comunicação ${operacao} com sucesso!`;
					const solicitacao = response.data;
			
					this.setState((prevState) => ({ ...prevState, solicitacao, }));
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const mensagemInicial = `Não foi possível ${this.state.solicitacao.id ? 'alterar' : 'incluir'} a solicitação de comunicação.`;
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState((prevState) => ({ ...prevState, botoesHabilitados : true}));
				});
		}
	
	}

) // redux
); // router